









import axios from 'axios';
import Vue from 'vue';
import eventBus from '@/eventBus';
import Modal from '@/components/Modal.vue';

export default Vue.extend({
  name: 'App',
  components: {
    Modal,
  },
  data: () => ({
    hotels: null,
    hotelsLoading: false,
    page: 1,
    itemsPerPage: 10,
    visiblePagesCount: 5,
    itemsCount: 0,
    isOpenModal: false,
    modalTarget: '',
  }),
  computed: {},
  methods: {
    getHotelsCount(): void {
      axios
        .get('https://jsonplaceholder.typicode.com/posts')
        .then(response => {
          this.itemsCount = response.data.length;
        })
        .catch(error => console.log(error));
    },
    loadHotels(): void {
      this.hotelsLoading = true;
      axios
        .get(`https://jsonplaceholder.typicode.com/posts?_page=${this.page}&_limit=10`)
        .then(response => {
          this.hotels = response.data;
        })
        .then(() => {
          this.hotelsLoading = false;
        })
        .catch(error => console.log(error));
    },
    paginatePage(clickPage: number): void {
      this.page = clickPage;
    },

    closeModal(): void {
      this.isOpenModal = false;
      document.querySelector('body').style.overflow = this.isOpenModal ? 'hidden' : 'auto';
    },

    openModal(modalTarget: string): void {
      this.isOpenModal = true;
      this.modalTarget = modalTarget;
      document.querySelector('body').style.overflow = this.isOpenModal ? 'hidden' : 'auto';
    },
  },
  watch: {
    page() {
      this.loadHotels();
    },
  },
  created() {
    this.getHotelsCount();
    this.loadHotels();
    eventBus.$on('showSuccesModal', (modalTarget: string): void => {
      this.openModal(modalTarget);
    });
  },
});
